import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { UrlModal } from "src/app/shared/url.model";
import { pipe } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DoctorsService {
  URL = "http://206.189.132.38:3005";
  //URL = "http://localhost:3005";

  constructor(private httpClient: HttpClient) {}

  saveDoctorToDatabase(
    name: string,
    email: string,
    password: string,

    phoneNo: number,
    token: string
  ) {
    return this.httpClient.post(
      UrlModal._URL + "/doc/regdoc",
      {
        name: name,
        email: email,
        password: password,

        phoneNo: phoneNo,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  getDoctorFromDb(token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    console.log(params);
    return this.httpClient
      .get<DoctorData>(UrlModal._URL + "/doc/getdoc/", {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
        params: params,
      })
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  getFilterDoctorFromDb(name, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .get<DoctorData>(
        UrlModal._URL + "/doc/getfilterDocName/" + name,

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  getFilterDoctorTypeFromDb(name, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .get<DoctorData>(
        UrlModal._URL + "/doc/getfilterDocType/" + name,

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  getFilterDoctorClinicFromDb(name, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .get<DoctorData>(
        UrlModal._URL + "/doc/getfilterDocClinic/" + name,

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  getMemberCouncil() {
    return this.httpClient
      .get<MemberCouncil>(UrlModal._URL + "/cn/getcouncil", {
        headers: new HttpHeaders({}),
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getCouncilCountry() {
    return this.httpClient
      .get<MemberCouncilCON>(UrlModal._URL + "/cn/getcouncilcountries", {
        headers: new HttpHeaders({}),
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getCouncilByCountry(country) {
    return this.httpClient
      .get<MemberCouncil>(UrlModal._URL + "/cn/getsinglecouncil/" + country, {
        headers: new HttpHeaders({}),
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getFilterDoctorCityFromDb(name, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .get<DoctorData>(
        UrlModal._URL + "/doc/getfilterDocCity/" + name,

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  getFilterDoctorStateFromDb(name, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .get<DoctorData>(
        UrlModal._URL + "/doc/getfilterDocState/" + name,

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  getSingleDoctorFromDb(id: string, token: string) {
    return this.httpClient
      .get<singleDoctorData>(UrlModal._URL + "/doc/doctor/" + id)
      .pipe(
        map((res) => {
          if (res.status === 200) {
            return res.data;
          }
        })
      );
  }
  savePatientLimit(id, limit, token) {
    this.httpClient
      .post(
        UrlModal._URL + "/doc/patientlimit",
        {
          patientLimit: limit,
          doctorId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .subscribe((res) => {});
  }
  savePatientNumber(id, patNum, token) {
    return this.httpClient
      .post(
        UrlModal._URL + "/doc/patientnumber",
        {
          patientNumber: patNum,
          doctorId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  getClinicDetails(id, token) {
    return this.httpClient
      .get<clinicTimingData>(UrlModal._URL + "/doc/clinic/" + id)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getHolidays(id, token) {
    return this.httpClient
      .get<clinicTimingData>(UrlModal._URL + "/doc/getholidays" + id)
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  setDoctorStatus(docId, isEnabled: boolean, token) {
    return this.httpClient
      .post(
        UrlModal._URL + "/doc/updatedocstatus",
        {
          doctorId: docId,
          isEnabled: isEnabled,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  updateDoctorToDatabase(
    name: string,
    doctorType: string,
    email: string,
    degree: string,
    line1: string,
    city: string,
    pincode: number,
    state: string,

    clinic: string,
    phoneNo: number,
    token: string,
    id: string,
    experience,
    firstVisitFee,
    mcId,
    membership,
    district
  ) {
    return this.httpClient.put(
      UrlModal._URL + "/ad/adminupdatedoc",
      {
        name: name,
        doctorType: doctorType,
        email: email,
        degree: degree,
        id: id,
        line1: line1,
        city: city,
        district: district,
        pincode: pincode,

        state: state,

        clinic: clinic,
        phoneNo: phoneNo,
        experience: experience,
        firstVisitFee: firstVisitFee,
        mcId: mcId,
        membership: membership,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  
  onDelete(id, token) {
    return this.httpClient.post(
      UrlModal._URL + "/ad/admindeletedoc",
      {
        id: id,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  onSearchDoctor(field, token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    return this.httpClient
      .get<DoctorData>(
        UrlModal._URL + "/doc/searchdoctor/" + field + "/",

        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  saveProfile(dpp, token) {
    const fd = new FormData();
    dpp.forEach((dp) => {
      fd.append("profileimage", dp, dp.name);
    });

    // fd.append("profileimage", dp, dp.name);
    //  fd.append("profileimage", dp, dp.name);

    fd.append("id", "5e454faf8ad0ef27c8404e61");
    return this.httpClient
      .post(UrlModal._URL + "/pat/uploadprofileimage", fd, {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      })
      .pipe((res) => {
        return res;
      });
  }

  setClinicTiming(startTime, endTime, id, token) {
    return this.httpClient
      .post(
        UrlModal._URL + "/doc/clinictiming",
        {
          startTime: startTime,
          endTime: endTime,
          doctorId: id,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
        }
      )
      .pipe((res) => {
        return res;
      });
  }

  onverify(id, token) {
    return this.httpClient.get(UrlModal._URL + "/ad/verifydoc/" + id, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }

  RegisterDoctorToDatabase(
    name: string,
    doctorType: string,
    email: string,
    experience: number,
    degree: string,

    line1: string,
    city: string,
    pincode: number,
    state: string,
    memberCouncil,
    patientLimit,

    consFee,
    clinicDays,

    clinic: string,
    phoneNo,
    password,
    memberCouncilId,
    district
  ) {
    return this.httpClient.post(UrlModal._URL + "/doc/adddoc", {
      name: name,
      doctorType: doctorType,
      email: email,
      experience: experience,
      degree: degree,

      line1: line1,
      city: city,

      pincode: pincode,
      district: district,
      state: state,

      clinic: clinic,
      memberCouncil: memberCouncil,
      patientLimit: patientLimit,

      consFee: consFee,
      clinicDays: clinicDays,
      phoneNo: phoneNo,
      password: password,
      memberCouncilId: memberCouncilId,
    });
  }

  AddnewClinic(clinicData, token) {
    return this.httpClient
      .post(UrlModal._URL + "/doc/addnewclinic", clinicData, {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      })
      .pipe(map((res) => {}));
  }

  getAllClinic(id, token) {
    return this.httpClient.post<AllclinicData>(
      UrlModal._URL + "/ad/getallclinic",
      {
        doctorId: id,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  onunverify(id, token) {
    return this.httpClient.get(UrlModal._URL + "/ad/unverifydoc/" + id, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }
  onpatApp() {
    return this.httpClient.post(
      UrlModal._URL + "/ap/patientappointment",
      {
        patientId: "5ed50c5b1cc9970f91791fc9",
      },
      {
        headers: new HttpHeaders({}),
      }
    );
  }
  editClinicById(id,data,token){
    return this.httpClient.post(
      UrlModal._URL + "/ad/editClinic/"+id , data, {
        headers : new HttpHeaders({
          authorization : "Bearer " + token
         })
      } 
    )
  }
  addLed(data,token){
    return this.httpClient.post(UrlModal._URL + "/led/addled",data,{
      headers:new HttpHeaders({
        authorization:"Bearer "+token
      })
    })
  }
  getLeds(docId,token){
    return this.httpClient.get(
      UrlModal._URL + "/led/getDocLeds/"+docId,{
        headers: new HttpHeaders({
          authorization :"Bearer "+ token
        })
      }
    )
  }
  uploadDp(formData: FormData, token: any) {
    console.log("final url",UrlModal._URL+'/doc/profileimage');
  return this.httpClient.post(`${UrlModal._URL}/doc/profileimage`, formData, {
    headers: new HttpHeaders({
        authorization:"Bearer " + token
      })
  });
}
  /* saveAdmin() {
    return this.httpClient.post(
      UrlModal._URL + "/ad/regadmin",
      {
        email: "satbirsaini786@gmail.com",
        phoneNo: 7307315489,
        password: "Tajfoods@321",
      },
      {
        headers: new HttpHeaders({}),
      }
    );
  }*/
}

export interface DoctorData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        name: string;
        doctorType: string;
        email: string;
        password: string;
        degree: [{ name: string }];
        profileStatus: {
          dailyLimit: boolean;
          scheduling: boolean;
        };
        isVerified: boolean;
        address: {
          line1: string;
          city: string;
          pincode: number;
          state: string;
        };
        clinic: string;
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}
export interface singleDoctorData {
  status: number;
  message: string;
  data: {
    _id: string;
    name: string;
    appointmentNumber: number;
    clinicId: [
      {
        address: {
          city: string;
          district: string;
          line1: string;
          pincode: string;
          state: string;
        };

        appointmentNumber: Number;
        clinicImages: string[];

        clinicImagesThumbnail: string[];

        clinicName: string;
        createdAt: string;
        doctorId: string;
        emergencyPatientLimit: number;
        isDeleted: boolean;
        isEmergencySlotOpened: boolean;
        isEnabled: boolean;
        patientLimit: number;
        patientNumber: 0;
      }
    ];
    doctorType: {
      isDeleted: boolean;
      _id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    };
    email: string;
    isVerified: boolean;
    experience: number;
    mcId: string;
    membership: string;
    password: string;
    degree: [
      {
        name: string;
      }
    ];
    address: { line1: string; city: string; pincode: number; state: string };
    clinic: string;
    phoneNo: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
/*
pointmentType":"NORMAL","patientHistory":[],"createdAt":"2020-06-12T06:31:38.280Z","updatedAt":"2020-06-12T06:31:38.280Z","__v":0
*/
export interface clinicTimingData {
  status: number;
  message: string;
  data: {
    patientLimit: number;
    patientNumber: number;
    appointmentNumber: number;
    isDeleted: boolean;
    isEnabled: boolean;
    _id: string;
    doctorId: string;
    __v: Number;
    createdAt: string;
    updatedAt: string;
  };

  /*    


{"status":200,"message":"getting data","data":{"docs":[{"address":{"line1":"sec 19",
"city":"chandigarh","pincode":6756565,"state":"PB"},"isDeleted":false,"isEnabled":true,
"_id":"5e2fddcfb395323968cd0957","name":"sam","doctorType":"5e21c988d2ca201f6c76ab2a",
"email":"sam123@gm","password":"$2a$10$pqfJGRaNKYZqsXANBUU/mee1lzlcX7qeNizJSG.t85zltB801r.jS",
"degree":"MD","clinic":"healthcare","phoneNo":69696969696,
"createdAt":"2020-01-28T07:07:59.985Z",
"updatedAt":"2020-01-28T07:07:59.985Z","__v":0},
{"address":{"line1":"goregaon","city":"mumbai","pincode":67565656,"state":"MH"},
"isDeleted":false,"isEnabled":true,"_id":"5e2fe35fda0b213bf872551c","name":"chaya",
"doctorType":"5e21c991d2ca201f6c76ab2b",
"email":"chaya123@gm","password":"$2a$10$3coY4CXwkEhX3x/uq/KE2eleE0Smf3VV4EzTMidMajb8JyoM.H6dC",
"degree":"DM","clinic":"chaya clinic","phoneNo":6575675765,
"createdAt":"2020-01-28T07:31:43.009Z","updatedAt":"2020-01-29T13:17:31.289Z","__v":0}],
"total":2,"limit":10,"page":1,"pages":1}}











*/
}

export interface MemberCouncil {
  status: string;
  message: string;
  council: {
    _id: string;
    isDeleted: boolean;
    councilName: [];
    country: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

export interface MemberCouncilCON {
  status: string;
  message: string;
  council: [
    {
      _id: string;
      country: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    }
  ];
}
export interface AllclinicData {
  status: number;
  message: string;
  clinics: [
    {
      clinicName: string;
      patientLimit: number;
      weekDays: string[];
      clinicImages: [];
      patientNumber: number;
      address: {
        line1: string;
        city: string;
        pincode: number;
        district: string;
        state: string;
      };

      emergencyPatientLimit: Number;
      appointmentNumber: number;
      isEmergencySlotOpened: boolean;
      isDeleted: boolean;
      isEnabled: boolean;
      _id: string;

      timming: {
        startTime: String;
        endTime: String;
      };
      doctorId: string;
      __v: Number;
      createdAt: string;
      updatedAt: string;
    }
  ];
}
